// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2325":"b3ac5e9c00d7ea2d","6088":"813542d7b872b6a7"}[chunkId] + ".js";
};